let iframeRef = null
let targetOrigin = '*'

export const initializePostMessage = (ref, origin = '*') => {
  iframeRef = ref
  targetOrigin = origin
}

const safeSerialize = data => {
  try {
    return JSON.parse(JSON.stringify(data))
  } catch (error) {
    console.warn('Failed to serialize data, attempting to clean:', error)

    const cleanData = obj => {
      if (obj === null || typeof obj !== 'object') {
        return obj
      }

      if (Array.isArray(obj)) {
        return obj.map(item => cleanData(item))
      }

      const cleaned = {}
      for (const [key, value] of Object.entries(obj)) {
        try {
          if (typeof value === 'function' || value === undefined) {
            continue
          }
          cleaned[key] = cleanData(value)
        } catch (err) {
          console.warn(
            `Skipping property ${key} due to serialization error:`,
            err
          )
        }
      }
      return cleaned
    }

    return cleanData(data)
  }
}

export const postMessageToChild = (type, data = {}) => {
  if (!iframeRef?.current?.contentWindow) {
    console.warn(
      'postMessage called but iframe ref or contentWindow not available'
    )
    return false
  }

  try {
    const message = {
      type,
      data: safeSerialize(data),
      timestamp: Date.now(),
      source: 'parent'
    }

    iframeRef.current.contentWindow.postMessage(message, targetOrigin)

    return true
  } catch (error) {
    console.error('Failed to post message to child iframe:', error)
    return false
  }
}

export const isIframeReady = () => {
  return !!iframeRef?.current?.contentWindow
}

export const cleanupPostMessage = () => {
  iframeRef = null
  targetOrigin = '*'
}
